/* eslint-disable no-unused-vars */
/*  eslint-disable jsx-a11y/click-events-have-key-events */
/*  eslint-disable jsx-a11y/no-static-element-interactions */
/*  eslint-disable space-infix-ops */
/*  eslint-disable eqeqeq */

import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, styled } from '@mui/material/styles';
import {
  Typography,
  Link,
  Grid,
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  IconButton,
  Button,
  useMediaQuery,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import Controls from '../controls';
import './styles.scss';

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  '& .MuiIconButton-root': {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  '& .dialog-title': {
    fontWeight: '600',
  },
}));

const StyledDialogContent = styled(MuiDialogContent)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  maxHeight: 'calc(100vh - 200px)', // leaves space for title + footer
  overflowY: 'auto',
}));

const StyledDialogActions = styled(MuiDialogActions)(({ theme }) => ({
  margin: 'auto',
  padding: theme.spacing(0, 0, 4),
}));

const FooterContainer = styled('div')(({ theme }) => ({
  justifyContent: 'center',
  textAlign: 'center',
  marginBottom: theme.spacing(3), // bottom margin
  display: 'flex',
  gap: theme.spacing(2), // space between items
  flexWrap: 'wrap', // makes it responsive
  '& .MuiButton-fullWidth': {
    width: 'auto',
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(0, 2),
}));

const TitleContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.25, 2.5),
  backgroundColor: '#0077C0',
  color: '#fff',
  fontSize: theme.spacing(2),
  textAlign: 'center',
}));

const CustomDialogTitle = (props) => {
  const {
    children, onClose, isHideClose, closeID, ...other
  } = props;

  return (
    <StyledDialogTitle disableTypography {...other}>
      <Typography variant="p" className="dialog-title">{children}</Typography>
      {!isHideClose ? (
        <IconButton aria-label="close" id={closeID} onClick={onClose}>
          <CloseIcon id="po-dialog-close-icon" />
        </IconButton>
      ) : null}
    </StyledDialogTitle>
  );
};

const DialogBox = (props) => {
  const {
    ActionToOpen, title, children, cancelLable, saveLable, submitLable, onSave, openDialog, setOpenDialog, className, checkOutClassName, footerStyle,
    width = 'md', isDisabled = false, isStripe = false, confirmation = false, onCancel, onSubmit, isHideClose, shippingChargeDialogStyle, closeId, submitID, saveID, cancelID, paynowCancelpop,
    backDropCloseNotAllowed,
    zIndex = 1300
  } = props;
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
    if (!paynowCancelpop) {
      setOpen && setOpen(false);
      setOpenDialog && setOpenDialog(false);
    }
  };

  const handleSave = () => {
    if (onSave) {
      onSave();
    }
    setOpen && setOpen(false);
    setOpenDialog && setOpenDialog(false);
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit();
    }
    setOpen && setOpen(false);
    setOpenDialog && setOpenDialog(false);
  };

  React.useEffect(() => {
    setOpen(Boolean(openDialog));
  }, [openDialog]);

  const removeSpace = data => data.replace(' ', '');

  return (
    <>
      <a onClick={handleClickOpen}>
        {ActionToOpen}
      </a>
      <Dialog
        onClose={(event, reason) => {          
          if ((reason === 'backdropClick' || reason === 'escapeKeyDown') && isStripe) {
            return;
          }
          if((reason === 'backdropClick' || reason === 'escapeKeyDown') && backDropCloseNotAllowed){
            return
          }
          handleClose();
        }}
        className={confirmation && shippingChargeDialogStyle ? `confirmation-text ${shippingChargeDialogStyle}` : confirmation ? 'confirmation-text' : className}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth={width}
        fullScreen={fullScreen}
        sx={{ zIndex: zIndex }}
      >
        {confirmation ? <TitleContainer className={`${className} xyz ${checkOutClassName}`}> {title}</TitleContainer>
          :
          title &&
          <CustomDialogTitle closeID={closeId} id="customized-dialog-title" onClose={handleClose} isHideClose={isHideClose}>
            {title}
          </CustomDialogTitle>
        }
        <StyledDialogContent>
          {children}
        </StyledDialogContent>
        {(cancelLable || saveLable) &&
          <FooterContainer style={typeof footerStyle == 'object' ? footerStyle : {}} className={typeof footerStyle == 'string' ? footerStyle : ''}>
            {cancelLable &&
              <Controls.Button variant="outlined" size="large" id={`dialog-${removeSpace(cancelLable)}-btn`} text={cancelLable} onClick={handleClose} sx={{ margin: (muiTheme) => muiTheme.spacing(0, 2) }} />
            }
            {saveLable &&
              <Controls.Button size="large" id={`dialog-${removeSpace(saveLable)}-btn`} variant={confirmation ? 'outlined' : ''} text={saveLable} onClick={handleSave} disabled={isDisabled} sx={{ margin: (muiTheme) => muiTheme.spacing(0, 2) }} />
            }
            {submitLable &&
              <Controls.Button size="large" id={`dialog-${removeSpace(submitLable)}-btn`} text={submitLable} onClick={handleSubmit} disabled={isDisabled} sx={{ margin: (muiTheme) => muiTheme.spacing(0, 2) }} />
            }
          </FooterContainer>
        }
      </Dialog>
    </>
  );
};

DialogBox.propTypes = {
  backDropCloseNotAllowed: PropTypes.bool,
};

export default DialogBox;
